import Radar from '@ks-radar/radar';

export default new Radar({
  projectId: 'e63900347a', // 雷达平台上的唯一标识
  sampling: 1, // 上报采样率，1 为全部上报
  APIHook(apiData) {
    const { response } = apiData;
    const data = JSON.parse(response.data);
    return {
      response_code: data.code,
      response_msg: data.message,
      status: response.status
    };
  }
});
